
<app-header 
  [fixed]="true"
  [navbarBrandFull]="{src: 'assets/img/brand/logowh.png', height: 30, alt: 'Robo-Advisor Logo'}"
  [navbarBrandMinimized]="{src: 'assets/img/brand/logowh.png', height: 30, alt: 'Robo-Advisor Logo'}"
  [sidebarToggler]="false"
  [mobileSidebarToggler]="false"
  [asideMenuToggler]="false"
  [mobileAsideMenuToggler]="false"
  >
  
    <!-- Dropdown Menu -->
    <ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown" dropdown placement="bottom right">

      <a class="nav-link" style="color:white" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
         Mon Compte  <i  style style="padding-left:5px" class="icon-user icons"></i>&nbsp;&nbsp;
      </a>

      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong >Bonjour {{email$}}</strong></div>
        <a (click)="GotoSupport()" class="dropdown-item" ><i class="fa fa-question-circle"></i>Support</a>
        <a (click)="logout(mymodal)" class="dropdown-item" ><i class="fa fa-sign-out"></i>Se déconnecter</a>

        <!-- model start here  -->
        <ng-template #mymodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title" style="color:#6600ff; font-weight: bold; font-size: 18px;">DÉCONNEXION</h4>
            <button type="button" class="close"    aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" style="font-size: 16px;">
            Êtes-vous sûr de quitter Robo Advisor ?
           </div>
          <div class="modal-footer">
           
            <button type="button" class="btn modele2" data-dismiss="modal" (click)="modal.dismiss('Cross click')" >Fermer</button>
            <button type="button" class="btn  modele" data-dismiss="modal" (click)="modal.close('Save click'); signout();">Confirmer</button>
            <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button> -->
          </div>
        </ng-template>
        <!-- model End here  -->

        <!-- <ng-template >
          <a class="dropdown-item"  [routerLink]="['/']" routerLinkActive="router-link-active"><i class="fa fa-unlock"></i>Se connecter</a>
        </ng-template> -->
        <!-- <a class="dropdown-item"><i class="fa fa-user"></i>Mon profil</a>
        <a class="dropdown-item" [routerLink]="['/auth/info']" routerLinkActive="router-link-active" ><i class="fa fa-wrench"></i>Auth Debug</a> -->
      </div>
      
    </li>
  </ul>
 
</app-header>


    <div class="pricing-table-2 ">
    
    
    
        <div class="ct">
      
          <div class="max-w-3xl mx-auto text-center">
            <h1 class="tex1">Profilage</h1>
            <p class="tex">Afin de mieux comprendre vos préférences et objectifs et de vous proposer des recommandations personnalisées, veuillez compléter votre profil. </p>
          </div>
<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

 

    <div class="content p-24">



        <div class="horizontal-stepper-wrapper">

            <mat-horizontal-stepper [linear]="true">

                <mat-step [stepControl]="horizontalStepperStep1">

                    <form fxLayout="column" [formGroup]="horizontalStepperStep1">

                        <ng-template matStepLabel>Informations personnelles</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">
                            
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                        <mat-label>Nom complet</mat-label>
                        <input matInput formControlName="fullname" required>
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>Champs vide!</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                        <mat-label>Adresse</mat-label>
                        <input matInput formControlName="adresse" required>
                        <mat-icon matSuffix class="secondary-text">home</mat-icon>
                        <mat-error>Champs vide!</mat-error>
                    </mat-form-field>

                </div>
                              <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                                <mat-form-field appearance="outline" fxFlex="100">
                                    <mat-label>Tranche d'âge</mat-label>
                                    <mat-select formControlName="age" required>
                                        <mat-option [value]="'Moins de 25'">
                                            Moins de 25 ans
                                        </mat-option>
                                        <mat-option [value]="'25-35'">
                                            Entre 25 et 35 ans        
                                        </mat-option>

                                        <mat-option [value]="'35-60'">
                                            Entre 35 et 60 ans        
                                        </mat-option>
                                        <mat-option [value]="'Plus de 60'">
                                            Plus de 60 ans
                                        </mat-option>
            
                                    </mat-select>
                                </mat-form-field>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100">
                                    <mat-label>Genre</mat-label>
                                    <mat-select formControlName="Genre" required>
                                        <mat-option [value]="'Femme'">
                                            Femme
                                        </mat-option>
                                        <mat-option [value]="'Homme'">
                                            Homme        
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                        </div>


                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>Occupation</mat-label>
                                <mat-select formControlName="occupation" required>
                                    <mat-option [value]="'Étudiant'">
                                        Étudiant(e)
                                    </mat-option>
                                    <mat-option [value]="'Employé'">
                                        Employé(e)        
                                    </mat-option>
                                    <mat-option [value]="'Entrepreneur'">
                                        Entrepreneur(e)        
                                    </mat-option>
                                    <mat-option [value]="'Employé'">
                                        Employé(e)        
                                    </mat-option>
                                    <mat-option [value]="'Ingénieur'">
                                        Ingénieur(e)        
                                    </mat-option>
                                    <mat-option [value]="'Enseignant'">
                                        Enseignant(e)        
                                    </mat-option>
                                    <mat-option [value]="'Freelancer'">
                                        Freelancer                                  
                                    </mat-option>
                                    <mat-option [value]="'Retraité'">
                                        Retraité(e)                                  
                                    </mat-option>
                                    <mat-option [value]="'Autreocp'">
                                        Autre                                 
                                    </mat-option>

                                </mat-select>
                            </mat-form-field>
                    </div>



                    </div>

                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button  mat-raised-button matStepperNext  type="button" style="background-color:#722add!important; color:white !important  ">
                                Suivant
                            </button>
                        </div>

                    </form>

                </mat-step>

                <mat-step [stepControl]="horizontalStepperStep2">

                    <form fxLayout="column" [formGroup]="horizontalStepperStep2">

                        <ng-template matStepLabel>Informations générales</ng-template>

            <div fxFlex="1 0 auto" fxLayout="row">

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                <mat-form-field appearance="outline" fxFlex="100">
                                    <mat-label>Revenu annuel</mat-label>
                                    <mat-select formControlName="RevenuAnn" required>
                                        <mat-option [value]="'Moins de 20000'">
                                            Moins de 20 000 TND
                                        </mat-option>
                                        <mat-option [value]="'20000-40000'">
                                            Entre 20 000 TND et 40 000 TND       
                                        </mat-option>
                                        <mat-option [value]="'40000-60000'">
                                            Entre 40 000 TND et 60 000 TND

                                        </mat-option>
                                        <mat-option [value]="'60000-80000'">
                                            Entre 60 000 TND et 80 000 TND
                                        </mat-option>
                                        <mat-option [value]="'Plus de 80000'">
                                            Plus de 80 000 TND
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
            
                    </div>
            </div>


            <div fxFlex="1 0 auto" fxLayout="row">

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>Dépenses mensuelles</mat-label>
                                <mat-select formControlName="DepensesMens" required>
                                    <mat-option [value]="'Moins de 500'">
                                        Moins de 500 TND
                                    </mat-option>
                                    <mat-option [value]="'500-1000'">
                                        Entre 500 TND et 1 000 TND
                                    </mat-option>
                                    <mat-option [value]="'1000-2000'">
                                        Entre 1 000 TND et 2 000 TND

                                    </mat-option>
                                    <mat-option [value]="'2000-3000'">
                                        Entre 2 000 TND et 3 000 TND
                                    </mat-option>
                                    <mat-option [value]="'Plus de 3000'">
                                        Plus de 3 000 TND
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
        
                </div>
        </div>


            <div fxFlex="1 0 auto" fxLayout="row">
                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>Objectif à court terme</mat-label>
                            <input matInput formControlName="ObjCourtTerme" placeholder=" exp:achat d'une voiture" required>
                            <mat-error>Champs vide!</mat-error>
                        </mat-form-field>
                        
                    </div> 
            </div>
            <div fxFlex="1 0 auto" fxLayout="row">
                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>Objectif à Long terme</mat-label>
                            <input matInput formControlName="ObjLongTerme" required placeholder="exp:Investissement dans des objectifs à long terme">
                            <mat-error>Champs vide!</mat-error>
                        </mat-form-field>
                    
                    </div> 
            </div>



            <div fxLayout="row" fxLayoutAlign="center center">
                <button class="mr-8" mat-raised-button matStepperPrevious type="button" style="background-color:#722add!important; color:white !important  ">
                    Précédent
                </button>
                <button mat-raised-button matStepperNext type="button" style="background-color:#722add!important; color:white !important ;">
                    Suivant
                </button>
            </div>

        </form>

    </mat-step>



                <mat-step [stepControl]="horizontalStepperStep3">

                    <form fxLayout="column" [formGroup]="horizontalStepperStep3">

                        <ng-template matStepLabel>Profil d'investisseur</ng-template>

                
                        <div fxFlex="1 0 auto" fxLayout="column">
                            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                              <mat-form-field appearance="outline" fxFlex="100">
                                  <mat-label>Connaissance financiére</mat-label>
                                  <mat-select formControlName="ConnaissanceFin" required>
                                      <mat-option [value]="'Débutant '">
                                        Débutant 
                                      </mat-option>
                                      <mat-option [value]="'Intermédiaire '">
                                        Intermédiaire        
                                      </mat-option>
                                      <mat-option [value]="'Avancé'">
                                        Avancé 
                                      </mat-option>
                                      <mat-option [value]="'Expert'">
                                        Expert  
                                      </mat-option>
          
                                  </mat-select>
                              </mat-form-field>
                         </div>
                         </div>
                         <div fxFlex="1 0 auto" fxLayout="column">

                         <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>Secteurs d'investissement</mat-label>
                                <mat-select formControlName="SecteurInves" required>
                                    <mat-option [value]="'Technologies'">
                                        Technologie
                                    </mat-option>
                                    <mat-option [value]="'Immobilier'">
                                        Immobilier        
                                    </mat-option>
                                    <mat-option [value]="'Energie'">
                                        Energie
                                    </mat-option>
                                    <mat-option [value]="'Santé'">
                                        Santé 
                                    </mat-option>
                                    <mat-option [value]="'Finance'">
                                        Finance 
                                    </mat-option>
                                    <mat-option [value]="'Industrie'">
                                        Industrie 
                                    </mat-option>
                                    <mat-option [value]="'Communication'">
                                        Communication  
                                    </mat-option>
                                    <mat-option [value]="'Matières premières '">
                                        Matières premières  
                                    </mat-option>
                                    <mat-option [value]="'AutreSecteurInves'">
                                        Autre  
                                    </mat-option>
        
                                </mat-select>
                            </mat-form-field>
                    </div>
                      
                    </div>


                    <div fxFlex="1 0 auto" fxLayout="column">

                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                           <mat-form-field appearance="outline" fxFlex="100">
                               <mat-label>Montant initial d'investissement</mat-label>
                               <mat-select formControlName="MontantInitInves" required>
                                   <mat-option [value]="'Moins de 1000'">
                                    Moins de 1 000 TND
                                   </mat-option>
                                   <mat-option [value]="'1000-5000'">
                                    Entre 1 000 et 5 000 TND        
                                   </mat-option>
                                   <mat-option [value]="'5000-10000'">
                                    Entre 5 000 et 10 000 TND
                                   </mat-option>
                                   <mat-option [value]="'10000-50000'">
                                    Entre 10 000 et 50 000 TND
                                </mat-option>
                                   <mat-option [value]="'Plus de 50000'">
                                    Plus de 50 000 TND
                               </mat-option>
       
                               </mat-select>
                           </mat-form-field>
                   </div>
                     
                </div>

                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button class="mr-8" mat-raised-button matStepperPrevious type="button" style="background-color:#722add!important; color:white !important  ">
                                Précédent
                            </button>
                            <button mat-raised-button matStepperNext type="button" style="background-color:#722add!important; color:white !important  " >
                                Suivant
                            </button>
                        </div>

                    </form>

                </mat-step>

                <mat-step>

                    <ng-template matStepLabel>Terminer</ng-template>

                    <div class="h2 m-16" fxLayout="row" fxLayoutAlign="center center">
                        Merci d'avoir compléter votre profil.
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button class="mr-8" mat-raised-button matStepperPrevious type="button" style="background-color:#722add!important; color:white !important  ">
                            Précédent
                        </button>
                        <button mat-raised-button type="button" style="background-color:#722add!important; color:white !important" (click)="finishHorizontalStepper()">
                            Terminer
                        </button>
                    </div>

                </mat-step>

            </mat-horizontal-stepper>

        </div>


    </div>

</div>

        </div>
        </div>
